module.exports = __webpack_public_path__ + "img/img3.76cc079d.png";